import { assert, getProxyHandler, setElementAttribute } from "./common";
import { Observable } from "./Observable";
/**
 * Element
 */
export class Element extends Observable {
    /**
     * Constructor
     * @param htmlElement html element
     * @param bindData bind data
     * @param context context
     * @protected
     */
    constructor(htmlElement, bindData, context) {
        super();
        this.htmlElement = htmlElement;
        this.bindData = bindData;
        this.context = context;
        setElementAttribute(this.htmlElement, 'id', this.generateId());
        // bind data
        let proxyHandler = getProxyHandler(bindData);
        assert(proxyHandler, 'ProxyHandler is not found');
        this.addObserver(proxyHandler);
        proxyHandler.addObserver(this);
    }
    /**
     * Generate id
     * @private
     */
    generateId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    /**
     * Gets html element
     */
    getHtmlElement() {
        return this.htmlElement;
    }
    /**
     * Gets context
     */
    getContext() {
        return this.context;
    }
    /**
     * Gets bind data
     */
    getBindData() {
        return this.bindData;
    }
}
//# sourceMappingURL=Element.js.map